// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".ca65798307f643892eee1d9d5e107de81b419204.chunk.js";
};